import { useEffect, useState } from "react";
import { ISelectProps } from "./Select.types";
import "./Select.css";
import Vector from "../Form/assets/vector.svg";

const Select = ({
  name,
  placeholder,
  options,
  state,
  setState,
  value,
  onChange,
}: ISelectProps) => {
  const [showOptionList, setShowOptionList] = useState(false);
  const [defaultSelectText, setDefaultSelectText] = useState("");
  const [documentClicked, setDocumentClicked] = useState(false);

  document.addEventListener("mousedown", (e: any) => {
    // console.log(!e.target.classList.contains("selected-text"))
    if (
      !e.target.classList.contains("custom-select-option") &&
      !e.target.classList.contains("selected-text")
    ) {
      setShowOptionList(false);
    }
    // if(e.target.classList.contains("selected-text") || e.target.classList.contains("select-placeholder")) {
    //   setDocumentClicked(true)
    // }
  });
  document.removeEventListener("mousedown", (e: any) => {
    if (
      !e.target.classList.contains("custom-select-option") &&
      !e.target.classList.contains("selected-text")
    ) {
      setShowOptionList(false);
    }
  });

  const handleListDisplay = (e: any) => {
    // if(e.target.classList.contains("selected-text")){
    setShowOptionList((prev: boolean) => !prev);
    // }
  };

  const handleOptionClick = (option: any) => {
    if (onChange) {
      onChange(option);
    }
    setDefaultSelectText(option.name);
    setShowOptionList(false);
    setState((prev: any) => ({
      ...prev,
      [name]: { ...state[name], value: option.name, id: option._id },
    }));
  };

  useEffect(() => {
    setDefaultSelectText(placeholder);
  }, []);

  return (
    <div className="custom-select-container">
      <div
        className={`${
          showOptionList ? "selected-text active" : "selected-text"
        } ${state[name].error && !state[name].value && "error"}`}
        onClick={handleListDisplay}
      >
        <p
          className={
            defaultSelectText === placeholder ? "select-placeholder" : ""
          }
        >
          {value ? value : placeholder}
        </p>
        <img src={Vector} alt="vector" className="vector" />
      </div>
      {state[name].error && !state[name].value && (
        <span className="error-message">Majburiy qator</span>
      )}
      {showOptionList && (
        <ul className="select-options">
          {options?.map((option: any, i: number) => {
            return (
              <li
                className="custom-select-option"
                data-name={option.name}
                key={i}
                onClick={() => handleOptionClick(option)}
              >
                {option.name}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default Select;
